import $ from 'jquery';

const slidersInit = () => {
  $('#js-certifications-list').slick({
    adaptiveHeight: true,
    accessibility: true,
    mobileFirst: false,
    infinite: false,
    arrows: true,
    dots: false,
    rows: 0,
    fade: false,
    slidesToShow: 5,
    responsive: [
      {
        breakpoint: 1080,
        settings: {
          arrows: true,
          dots: false,
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 900,
        settings: {
          arrows: true,
          dots: false,
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 620,
        settings: {
          arrows: true,
          dots: false,
          slidesToShow: 2,
        },
      },
      {
        breakpoint: 420,
        settings: {
          arrows: true,
          dots: false,
          slidesToShow: 1,
        },
      },
    ],
  });
};
export default slidersInit;



// WEBPACK FOOTER //
// ./wp/wp-content/themes/ct-cubed-chisel/src/scripts/modules/sliders-init.js